import { Component, Prop, h, State } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { renderFeedback } from './feedback-rendering-helpers';
import { medaliaGenAiConfigurationObject } from '../../../../../../utils/medalia-integration/medalia-configurations';
import { showMedaliaComponent } from '../../../../../../utils/medalia-integration/medalia-integration';
import { eventDispatcherForFunctionalComponents } from '../../../conversational-search-logic/utils/utils';

@Component({
  tag: 'uiaas-search-widget-conversational-search-dynamic-banner-feedback',
  styleUrl: 'feedback.scss',
  shadow: false,
})
export class WidgetConversationalSearchDynamicBannerFeedback {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly query: string;
  @Prop() readonly language: string;
  @Prop() readonly country: string;
  @Prop() readonly conversationalSearchMedaliaFormId?: string;

  @State() activeVariant: string;

  render() {
      const callback = (variant: string) => (this.activeVariant = variant);
      const medaliafallback = () => eventDispatcherForFunctionalComponents('conversational-search:medalia-fallback-banner');
      const medalliaCallback = () => showMedaliaComponent(this.conversationalSearchMedaliaFormId, medaliaGenAiConfigurationObject(this.country, this.language), medaliafallback);

      return (
        <section class="conversational-search-banner-dynamic-feedback">
          {renderFeedback(this.labelProvider, this.query, this.activeVariant, callback, medalliaCallback)}
        </section>
      );
  }
}
